import Plaatjie from '@ubo/plaatjie'
import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'

const Section = styled.section`
  padding-block: 6rem;
`

const HeroWrapper = styled.div`
  position: relative;

  @media (max-width: 575px) {
    .gradient-left,
    .gradient-right {
      display: none;
    }
  }

  & .gradient-left {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 20%;
    height: 100%;
    background: linear-gradient(-270deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
  }

  & .gradient-right {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    width: 20%;
    height: 100%;
    background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
  }

  img {
    min-height: 400px;
    max-width: 100%;
  }
`

const InnerWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;

  & img {
    object-fit: contain;
    max-width: 100%;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1000px;
    margin-inline: auto;

    & h2 {
      color: #fff;
      text-align: right;
      margin-right: 2rem;
      line-height: 90%;
      margin-top: 15px;
    }
  }

  ul {
    @media (min-width: 992px) {
      margin-left: 6rem;
    }
    @media (max-width: 991.98px) {
      margin-top: 1rem;
    }
  }

  ul li {
    color: #fff !important;
    font-weight: bold;
  }

  @media (min-width: 992px) {
    ul li {
      font-size: 28px;
    }
  }

  @media (max-width: 991.98px) {
    > div {
      flex-direction: column;

      svg {
        max-height: 100px;
      }
    }
  }
`

function HeroDetail({ description, image, items }) {
  return (
    <Section>
      <HeroWrapper>
        <div className="gradient-left" />
        <div className="gradient-right" />
        <Plaatjie image={image} />
        <InnerWrapper className="container">
          <div>
            <div className="d-flex align-items-center">
              <ParseContent content={description} />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="114"
                height="190"
                viewBox="0 0 114 190"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M26.0603 0L0.537109 25.2426V190H66.6808L93.0277 164.756V151.844H66.6808V164.756H13.9852L26.884 152V25.2426H66.6808V37.9969H93.0277V0H26.0603Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M73.4419 46.1582L66.8426 52.7892V59.2791H98.7171V86.7903H86.0801L78.7776 93.4207V100.052H99.9812V131.795H72.7399L66.1406 138.284V144.915H100.403L113.461 131.795V98.9234L107.143 92.7154L111.776 88.0598V46.1582H73.4419Z"
                  fill="#D50021"
                />
              </svg>
            </div>

            <ul>
              {items.map((edge) => (
                <li>{edge.title}</li>
              ))}
            </ul>
          </div>
        </InnerWrapper>
      </HeroWrapper>
    </Section>
  )
}

export default HeroDetail
